import React, { useEffect, useState } from 'react'
import classnames from 'classnames'
import { message, Button } from 'antd'
import moment from 'moment'
import { picProcess } from '../../../utils/image'
import Modal from '../../../baseComponent/modal'
import request from '../../../utils/request'
import InsList from '../../uploadIns/insList'
import Cascade from '../../../baseComponent/select/cascade'
import Icon from '../../icon'
import TagList from '../tagList'
import './sku.less'

const SELECT_STYLE = {
  display: 'flex',
  lineHeight: '32px',
  width: 184,
  height: 32,
  color: '#282b59',
  borderRadius: '2px',
  border: '1px solid #D4D5E0',
  padding: '0 12px',
  justifyContent: 'space-between',
  alignItems: 'center',
}

const SEASON_OPTIONS = [
  { label: '春', value: 1 },
  { label: '夏', value: 2 },
  { label: '秋', value: 3 },
  { label: '冬', value: 4 },
]
const SAMPLE_PURPOSE_OPTIONS = [
  { label: '展厅使用', value: 1 },
  { label: '客户定向', value: 2 },
  { label: '其他', value: 3 },
]

function Row({ name, children, required }) {
  return (
    <div className="ins-add-inspiration-row">
      <div style={{ marginRight: 8 }}>
        {required && <span style={{ color: '#DA583F' }}>*</span>}
        {name}
      </div>
      <div className="content">{children}</div>
    </div>
  )
}

function RadioButtonGroup({ options, onChange, value }) {
  const onClickItem = (item) => {
    if (item.value === value) {
      onChange(null)
    } else {
      onChange(item.value, item)
    }
  }
  return (
    <ul className="ins-radio-button-group">
      {options.map((m) => (
        <li onClick={() => onClickItem(m)} className={classnames('item', { active: m.value === value })}>
          {!!m.img && <img src={picProcess(m.img)} />}
          {m.label}
        </li>
      ))}
    </ul>
  )
}
function NumberInput({ value, onChange, step = 1, min = 0, max = Number.MAX_VALUE }) {
  const events = {
    tick: 0,
    onAdd() {
      onChange(Math.min(Number(value) + step, max))
    },
    onSubtract() {
      onChange(Math.max(Number(value) - step, min))
    },
    onChange(e) {
      const _value = Number(e.target.value)
      if (/^\d+?$/.test(_value)) {
        onChange(Math.max(Math.min(_value, max), min))
      }
    },
  }
  return (
    <div className="df-number-input">
      <input onChange={events.onChange} value={value} />
      <div className="number-input-btns">
        <a className={classnames('number-input-btn', 'subtract', { disabled: value === min })} onMouseDown={() => events.onAdd()}>
          <Icon type="m-Vxing_shang" />
        </a>
        <a className={classnames('number-input-btn', 'add', { disabled: value === max })} onMouseDown={() => events.onSubtract()}>
          <Icon type="m-Vxing_xia" />
        </a>
      </div>
    </div>
  )
}
NumberInput.defaultProps = {
  step: 1,
  min: 0,
  max: Number.MAX_VALUE,
}
export default function ({ onSubmit, onClose, itemInfo, onChangeMainImage, tags, onAddTag, onDeleteTag }) {
  const [value, setValue] = useState({ count: 1, size: null, color: null, season: null, categoryId: null, samplePurpose: 1 })
  const [skuOptions, setSkuOptions] = useState({})
  const [categoryOptions, setCategoryOptions] = useState([])
  const [idList, setIdList] = useState([])
  const [isOnSale, setIsOnSale] = useState(false)
  const [checkOnSaleLoading, setCheckOnSaleLoading] = useState(true)
  const defaultCateogry = 6
  useEffect(() => {
    request.post('/whale-api/v1_0/sample-manage/goods/category-selector', {}, { baseURL: '' }).then((res) => {
      setCategoryOptions(
        res
          .filter((m) => m.categoryLevel === 1)
          .map((m) => {
            return {
              label: m.categoryName,
              value: m.id,
              children: res
                .filter((k) => k.parentId === m.id)
                .map((k) => {
                  return {
                    label: k.categoryName,
                    value: k.id,
                    parent: res.filter((j) => j.parentId === m.id).length ? { label: m.categoryName, value: m.id } : undefined,
                  }
                }),
            }
          })
      )
    })
  }, [])
  useEffect(() => {
    if (!itemInfo.itemId) return
    setCheckOnSaleLoading(true)
    request
      .get('/item/sku-info', { params: { itemId: itemInfo.itemId } })
      .then((options) => {
        setSkuOptions(options)
        let defaultSize = null
        if (options.skuMeasurement) {
          // 找出包含 “S” 关键字的尺码，无则返回第一个
          defaultSize = options.skuMeasurement.find((m) => /s/gi.test(m)) || options.skuMeasurement?.[0]
        }
        if (options.colorPicMapping) {
          onChangeMainImage(options.colorPicMapping?.[options.skuColor?.[0]])
        }
        setValue({
          ...value,
          img: options.colorPicMapping?.[options.skuColor?.[0]],
          size: defaultSize,
          color: options.skuColor?.[0],
          season: options.season || 1,
          categoryId: Number(options.categoryId) || defaultCateogry,
        })
        setCheckOnSaleLoading(false)
        setIsOnSale(true)
      })
      .catch(() => {
        setCheckOnSaleLoading(false)
        setIsOnSale(false)
      })
  }, [itemInfo.itemId])
  const _onChangeColor = (val) => {
    onChangeValue(val)
    console.log(val)
    onChangeMainImage?.(val?.img)
  }
  const onChangeValue = (val) => {
    setValue({ ...value, ...val })
  }
  const _onSubmit = async () => {
    if (checkOnSaleLoading) {
      message.error('正在获取采买信息，请稍后')
      return
    }
    if (!isOnSale) {
      message.error('该商品已下架，不支持采买')
      return
    }
    const conditions = [
      { verify: () => value.categoryId > 0, errorMessage: '请选择类目' },
      { verify: () => value.season > 0, errorMessage: '请选择季节' },
      { verify: () => !skuOptions.skuMeasurement?.length || value.size, errorMessage: '请选择尺码' },
      { verify: () => !skuOptions.skuColor?.length || value.color, errorMessage: '请选择颜色' },
      { verify: () => idList.length > 0, errorMessage: '请选择要加入的灵感集' },
    ]
    for (let i = 0; i < conditions.length; i++) {
      const condition = conditions[i]
      if (!condition.verify()) {
        message.error(condition.errorMessage)
        return
      }
    }
    const insPurchaseItemParam = {
      categoryId: value.categoryId,
      itemName: itemInfo.title || itemInfo.itemTitle,
      mainUrl: value.img || itemInfo.mainUrl || itemInfo.picUrl,
      price: itemInfo.price,
      shopName: itemInfo.shopName,
      purchaseNum: value.count,
      season: value.season,
      shopId: itemInfo.shopId,
      skuColor: value.color,
      skuMeasurement: value.size,
      samplePurpose: value.samplePurpose,
    }
    const res = await request.get('/zhikuan/ins/inspiration/list-team-purchase-user', { params: { itemId: itemInfo.itemId } })
    if (!res) {
      onSubmit?.({ insPurchaseItemParam, idList })
      return
    }
    Modal.show({
      title: '提示',
      content: (
        <div style={{ fontSize: '14px', fontWeight: 400, marginBottom: '16px' }}>
          成员 - <span style={{ fontSize: 16, fontWeight: 600 }}>{res.map((m) => m.name).join('、')}&nbsp;</span>于
          {moment(res[0].purchaseTime).format('YYYY-MM-DD')}已采买该款式，是否继续采买？
        </div>
      ),
      okText: '采买',
      cancelText: '不采买',
      onCancel() {
        onClose()
      },
      onOk() {
        onSubmit?.({ insPurchaseItemParam, idList })
      },
    })
  }
  return (
    <div className="mn-add-idea-masses-wrapper" style={{ overflow: 'unset' }}>
      <div className="idea-masses-wrapper">
        {!!itemInfo.itemId && (
          <Row name="加入">
            <InsList
              multiple={false}
              unionId={itemInfo.itemId}
              onChange={(val) => setIdList(val)}
              style={{ marginLeft: 0, marginRight: 40 }}
            />
          </Row>
        )}
        <div className="img-info-wrap">
          {skuOptions.skuMeasurement?.length > 0 && (
            <Row required name="尺码">
              <RadioButtonGroup
                value={value.size}
                onChange={(val) => onChangeValue({ size: val })}
                options={skuOptions.skuMeasurement.map((m) => ({ label: m, value: m }))}
              />
            </Row>
          )}
          {skuOptions.skuColor?.length > 0 && (
            <Row required name="颜色">
              <RadioButtonGroup
                value={value.color}
                onChange={(val, item) => _onChangeColor({ color: val, img: item?.img })}
                options={skuOptions.skuColor.map((m) => ({ label: m, value: m, img: skuOptions.colorPicMapping?.[m] }))}
              />
            </Row>
          )}
          <Row required name="品类">
            <Cascade
              trigger="click"
              placement="bottomLeft"
              style={SELECT_STYLE}
              allowClear={false}
              value={value.categoryId}
              onChange={(categoryId) => onChangeValue({ categoryId })}
              options={categoryOptions}
            />
          </Row>
          <Row required name="季节">
            <Cascade
              trigger="click"
              style={SELECT_STYLE}
              value={value.season}
              allowClear={false}
              onChange={(val) => onChangeValue({ season: val })}
              options={SEASON_OPTIONS}
            />
          </Row>
          <Row required name="数量">
            <NumberInput value={value.count} min={1} max={9999} onChange={(val) => onChangeValue({ count: val })} />
          </Row>
          <Row required name="样衣用途">
            <Cascade
              trigger="click"
              style={SELECT_STYLE}
              allowClear={false}
              value={value.samplePurpose}
              onChange={(val) => onChangeValue({ samplePurpose: val })}
              options={SAMPLE_PURPOSE_OPTIONS}
            />
          </Row>
        </div>
        <Row name="标签">
          <TagList style={{ width: 350, margin: 0 }} onAdd={onAddTag} onDelete={onDeleteTag} value={tags} />
        </Row>
      </div>
      <div style={{ flex: 1 }} />
      <div className="inspiration-footer" style={{ textAlign: 'right' }}>
        <Button type="link" onClick={onClose} style={{ color: '#C8C9D7' }}>
          取消
        </Button>
        <Button type="primary" onClick={_onSubmit}>
          确定
        </Button>
      </div>
    </div>
  )
}
